import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import {devicesActions, geofencesActions} from './store';
import EditCollectionView from './EditCollectionView';
import {useEffectAsync} from "./reactHelper";
import {cyberStyles} from "./cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
  ...cyberStyles(theme),
  list: {
    width: '100%',
    overflowY: 'auto',
  },
  listItem: {
    padding: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const GeofenceView = ({ updateTimestamp, onMenuClick }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const items = useSelector(state => Object.values(state.geofences.items));


  useEffectAsync(async () => {
    const response = await fetch('/api/geofences');
    if (response.ok) {
      let res = await response.json();
      dispatch(geofencesActions.refresh(res));
    }
  }, [updateTimestamp]);


  return (
      <List className={classes.list}>
        {items.map((item) => (
            <ListItem
                button
                dense
                key={item.id}
                onClick={() => dispatch(devicesActions.select(item))}
                className={classes.listItem}
            >
              <ListItemText className={classes.moreIcon} primary={item.name} />
              <ListItemSecondaryAction>
                <IconButton className={classes.moreIcon} onClick={(event) => onMenuClick(event.currentTarget, item.id)}>
                  <MoreVertIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
        ))}
      </List>
  );
}

const GeofencesList = () => {

  return (
      <EditCollectionView content={GeofenceView} editPath="/geofence" endpoint="geofences" disableAdd />

  );
}

export default GeofencesList;
